// The seven styles of play, plus Endurance.
//
// `route` is what the mode picker pushes. Every one of these is a real screen
// under /tabs/play/, so each keeps the tab bar and gets a back button for
// free — see src/pages/SHELL.md.

import {
  linkOutline,
  swapVerticalOutline,
  searchOutline,
  timerOutline,
  eyeOutline,
  reorderFourOutline,
  todayOutline,
  flameOutline,
} from 'ionicons/icons';

export const MODES = [
  {
    id: 'chain-reaction',
    name: 'Chain Reaction',
    route: '/tabs/play/chain-reaction',
    icon: linkOutline,
    emoji: '🔗',
    blurb: 'Every answer has to link to the last one. Keep it going.',
    pressure: 'One wrong link and the whole chain drops.',
    tint: 'chain',
  },
  {
    id: 'higher-lower',
    name: 'Higher or Lower',
    route: '/tabs/play/higher-lower',
    icon: swapVerticalOutline,
    emoji: '⚖️',
    blurb: 'Two things. Pick the bigger, faster, older or heavier one.',
    pressure: 'One tap. No thinking time.',
    tint: 'higher',
  },
  {
    id: 'odd-one-out',
    name: 'Odd One Out',
    route: '/tabs/play/odd-one-out',
    icon: searchOutline,
    emoji: '🔍',
    blurb: 'Four things, one impostor. Bonus points if you know why.',
    pressure: 'It gets sneaky. Fast.',
    tint: 'odd',
  },
  {
    id: 'last-gasp',
    name: 'Last Gasp',
    route: '/tabs/play/last-gasp',
    icon: timerOutline,
    emoji: '💨',
    blurb: 'Sixty seconds of true or false. Wrong answers cost SECONDS.',
    pressure: 'The mode this whole app is named after.',
    tint: 'gasp',
  },
  {
    id: 'guess-the-thing',
    name: 'Guess the Thing',
    route: '/tabs/play/guess-the-thing',
    icon: eyeOutline,
    emoji: '👁️',
    blurb: 'It comes into focus one clue at a time. Guess early, score big.',
    pressure: 'Every clue you wait for costs you points.',
    tint: 'guess',
  },
  {
    id: 'sort-it',
    name: 'Sort It',
    route: '/tabs/play/sort-it',
    icon: reorderFourOutline,
    emoji: '📊',
    blurb: 'Five things. Put them in the right order before the clock goes.',
    pressure: 'The timer never stops.',
    tint: 'sort',
  },
];

/** The two headline modes, which live in the tab bar rather than the picker. */
export const DAILY_MODE = {
  id: 'daily',
  name: 'Daily EXHAUSTIN',
  route: '/tabs/daily',
  icon: todayOutline,
  emoji: '📅',
  blurb: 'One puzzle. One attempt. Come back tomorrow.',
  tint: 'daily',
};

export const ENDURANCE_MODE = {
  id: 'endurance',
  name: 'Endurance',
  route: '/tabs/endurance',
  icon: flameOutline,
  emoji: '🔥',
  blurb: 'It never stops. It only gets faster. How long can you last?',
  tint: 'endurance',
};

export const ALL_MODES = [...MODES, DAILY_MODE, ENDURANCE_MODE];

export const modeById = (id) => ALL_MODES.find((m) => m.id === id) ?? null;
export const modeName = (id) => modeById(id)?.name ?? id;
export const modeEmoji = (id) => modeById(id)?.emoji ?? '🎯';
